import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'
@Component({
  selector: 'ddc-small-pair',
  templateUrl: './ddc-small-pair.component.html',
  styleUrl: './ddc-small-pair.component.scss',
  imports: [AngularMaterialsModules, CommonModule, RouterModule],
})
export class DdcSmallPairComponent {
  @Input('pair') _pair: any
  @Input('with_icon') _withIcon: boolean = false

  _isString: boolean = true

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  private themeSubscription: Subscription

  constructor(public themeService: ThemeService) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }
}
